
    import { Vue, Component, Prop } from 'vue-property-decorator'

    @Component({
        name: 'SiteTermsDialog'
    })

    export default class SiteTermsDialog extends Vue {
        @Prop(Boolean) value!: boolean;

        get visible() { return this.value; }

        set visible(value) {
            this.$emit('input', value);
        }

        acceptTerms() {
            localStorage.removeItem('SiteTermsNotAccepted');
            this.visible = false;
        }
    }
